import React from 'react';
import { Link } from 'react-router-dom';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='invoice' component={Static} horizontal label={t('Voucher_InvoiceNumber')} />
			<Field name='code' component={Static} horizontal label={t('Voucher_Code')} />
			<Field name='usedBy' component={Static} horizontal label={t('Voucher_UsedBy')} />
			<Field name='boughtBy' component={Static} horizontal label={t('Voucher_BoughtBy')} />
			<Field name='phoneNumber' component={Static} horizontal label={t('Voucher_PhoneNumber')} />
			<Field name='email' component={Static} horizontal label={t('Voucher_Email')} />
			<Field name='amount' component={Static} horizontal label={t('Voucher_Amount')} />
			<Field name='balance' component={Input} type='text' horizontal required label={t('Voucher_Balance')} validate={[validators.required, validators.number]} />
			<Field name='paymentMethod' component={Static} horizontal label={t('Voucher_PaymentMethod')} />
			<Field name='transaction' component={Static} horizontal label={t('Voucher_Transaction')} />
			<Field name='status.name' component={Static} horizontal label={t('Voucher_Status')} />
			<Field name='activationCode' component={Static} horizontal label={t('Voucher_ActivationCode')} />
			<Field name='isActive' component={Checkbox} disabled={isReadonly} horizontal label={t('Voucher_IsActive')} normalize={(v) => { return !!v }} />

			<FormActions horizontal>
				<Link to='/vouchers' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'voucher', enableReinitialize: true })(withTranslation()(SettingsForm));
